<template>
  <v-form
    class="bg-light py-md-3 py-1 px-3 rounded mb-1"
    @submit.prevent="submit()"
  >
    <div class="form-row">
      <div v-if="certificate.id" class="col-1">
        ID: {{ certificate.id }}
      </div>
      <div class="col-6">
        <div class="pb-0">
          <v-text-field
            v-model="certificate.name"
            label="Name*"
            bg-color="white"
            variant="outlined"
            density="compact"
            :error-messages="v$.certificate.name.$errors.map((e) => e.$message)"
            @blur="v$.certificate.name.$touch()"
          />
        </div>
      </div>

      <div class="col-3">
        <div class="pb-0">
          <v-text-field
            v-model="certificate.validity_period"
            type="number"
            step="1"
            label="Validity Period (days)*"
            bg-color="white"
            variant="outlined"
            density="compact"
            :error-messages="
              v$.certificate.validity_period.$errors.map((e) => e.$message)
            "
            @blur="v$.certificate.validity_period.$touch()"
          />
        </div>
      </div>

      <div class="col-2 my-auto pb-3">
        <button
          v-if="certificate.id"
          type="button"
          class="btn btn-default btn-sm"
          :disabled="saveInProgress"
          @click="save"
        >
          Save
          <span
            v-show="saveInProgress"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
        <button
          v-if="certificate.id"
          type="button"
          class="btn btn-default btn-sm"
          :disabled="saveInProgress"
          @click="remove"
        >
          Delete
          <span
            v-show="deleteInProgress"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
        <button
          v-if="!certificate.id"
          type="button"
          class="btn btn-default btn-sm mb-3"
          :disabled="addInProgress"
          @click="add"
        >
          Add
          <span
            v-show="addInProgress"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </v-form>
</template>

<script>
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core';
import { lookup } from '../lookup/lookup';

import { appValidator } from '../../common/core/utils/validator';

export default {
  props: ['modelValue', 'index'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      lookup,
      certificate: { ...this.modelValue },
      saveInProgress: false,
      deleteInProgress: false,
      addInProgress: false,
    };
  },

  validations() {
    return {
      certificate: {
        name: {
          required: appValidator.required,
        },
        validity_period: {
          required: appValidator.required,
        },
      },
    };
  },

  methods: {
    validate() {
      let error = false;
      if (this.v$.$invalid) {
        this.v$.$touch();
        error = true;
      }

      return !error;
    },

    async save() {
      if (!this.validate()) {
        return;
      }

      this.saveInProgress = true;
      const response = await axios.put(
        `/api/certificates/${this.certificate.id}`,
        this.certificate,
      );
      this.saveInProgress = false;

      this.$emit('save-certificate', this.certificate);
    },

    async add() {
      if (!this.validate()) {
        return;
      }

      this.addInProgress = true;

      const response = await axios.post('/api/certificates', this.certificate);
      this.certificate.id = response.data.id;

      this.addInProgress = false;

      this.$emit('add-certificate', this.certificate);
    },

    async remove() {
      if (confirm('Do you really want to delete?')) {
        this.deleteInProgress = true;
        const response = await axios.delete(
          `/api/certificates/${this.certificate.id}`,
          this.certificate,
        );
        this.deleteInProgress = false;
        this.$emit('remove-certificate', this.certificate);
      }
    },
  },
};
</script>
